var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TotemSelect',{ref:"select",staticClass:"filter-select",class:(_vm.$totemLang + "-" + _vm.filterKey),attrs:{"options":_vm.options,"placeholder":_vm.placeholder,"isFilter":true,"closeOnSelect":false,"reduce":function (ref) {
	var value = ref.value;
	var label = ref.labelWithoutCount;

	return ({ value: value, label: label });
},"value":_vm.selectedValue},on:{"input":_vm.onInput,"removeOptionFromFilters":_vm.removeFilterValue}})}
var staticRenderFns = []

export { render, staticRenderFns }